export default __webpack_public_path__ + "static/media/200_4V_TECNOLOGIA_RT_01.aeab3e40.jpg";